$(function () {
  // Pagination
  $.each($('.pagination__textfield'), function (index, item) {
    $(item).on('keypress', function (ev) {
      if (ev.which == 13) {
        var page = $(ev.target).val().trim();
        window.location.href = $(ev.target).attr('data-href') + '&page=' + page;
      }
    });
  });

  // Autoresize textareas
  addAutoResize();
});

// Add form check

var formSubmitted = false;
var formUserInput = false;
var allowUserInputCheck = false;

$(function () {
  var form = $('.edit__form');
  if (form.length) {

    setTimeout(function () {
      form.addClass('-init');
    }, 240);

    form.on('submit', function () {
      formSubmitted = true;
    });

    // Reset input events set by JavaScript
    setTimeout(function () {
      allowUserInputCheck = true;
      formUserInput = false;
    }, 500);

    form.find('[data-check-unload-event]').on('input change', function () {
      formUserInput = true;
    });

    window.onbeforeunload = function () {
      if (allowUserInputCheck && formUserInput && !formSubmitted) {
        return 'Möchten Sie die Seite wirklich verlassen?';
      }
    };
  }
});

// Toggle user nav

function toggleUserNav() {
  $('body').toggleClass('user-menu-open');
  $('body').hasClass('user-menu-open') ? openUserNav() : closeUserNav();
}

function closeUserNav() {
  $('body').removeClass('user-menu-open');
  $('.user-menu__wrapper').slideUp(250);
}

function openUserNav() {
  $('body').addClass('user-menu-open');
  $('.user-menu__wrapper').slideDown(250);
}

// Show no content or list item sections

// function showNoContentSection() {
//   $('.list-items__wrapper').removeClass('list-items__wrapper--active');
//   $('.list-items__no-content').addClass('list-items__no-content--active');
// }

// function removeNoContentSection() {
//   $('.list-items__wrapper').addClass('list-items__wrapper--active');
//   $('.list-items__no-content').removeClass('list-items__no-content--active');
// }

// function checkListContent(selector) {
//   if ($(selector).length) {
//     removeNoContentSection();
//   } else {
//     showNoContentSection();
//   }
// }

// function removeListItem(selector, selectorListItems, callback) {
//   $(selector).fadeOut(500, function() {
//     $(this).remove();
//     checkListContent(selectorListItems || '.list-items__container .list-item__wrapper');
//     callback && callback();
//   });
// }

// Toggle checkboxes

// function toggleCheckbox(id) {
//   var container = $('.checkbox__container[data-id="' + id + '"]');
//   container.attr('data-value') == '1' ? uncheckCheckbox(id) : checkCheckbox(id);
// }

// function checkCheckbox(id) {
//   var container = $('.checkbox__container[data-id="' + id + '"]');
//   container.attr('data-value', 1);
//   container
//     .find('.checkbox__icon')
//     .removeClass('icon-checkbox')
//     .addClass('icon-checkbox-checked');
//   container.removeClass('error');
// }

// function uncheckCheckbox(id) {
//   var container = $('.checkbox__container[data-id="' + id + '"]');
//   container.attr('data-value', 0);
//   container
//     .find('.checkbox__icon')
//     .removeClass('icon-checkbox-checked')
//     .addClass('icon-checkbox');
//   container.removeClass('error');
// }
